/* Roster Jersey cart patch (2026-07):
   theme.min.js only handles status 422 from /cart/add.js and silently treats
   404/other errors as success. This wrapper surfaces every add-to-cart failure
   so errors are visible instead of an empty cart drawer. */
(function () {
  var origFetch = window.fetch;
  window.fetch = function (url) {
    var p = origFetch.apply(this, arguments);
    try {
      if (typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
        p.then(function (res) {
          return res.clone().text().then(function (txt) {
            var data = null;
            try { data = JSON.parse(txt); } catch (e) {}
            if (!res.ok || (data && data.status)) {
              var msg = (data && (data.description || data.message)) || ('HTTP ' + res.status);
              console.error('[RosterJersey] Add to cart failed:', res.status, txt.slice(0, 500));
              alert('Could not add to cart: ' + msg);
              document.querySelectorAll('.add-to-cart.btn--loading').forEach(function (b) {
                b.classList.remove('btn--loading');
              });
            }
          });
        }).catch(function (err) {
          console.error('[RosterJersey] Add to cart request error:', err);
        });
      }
    } catch (e) {}
    return p;
  };
})();
